module.exports = __webpack_public_path__ + "static/img/introduce.a0b6f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce.png
// module id = fSaK
// module chunks = 1